import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { selectCurrentOrg } from "../auth/state/selectors";
import { paths } from "../../_app/router/paths";

const OnboardingRoute = () => {
  const currentOrg = useSelector(selectCurrentOrg);

  // Block access if already onboarded
  if (currentOrg?.orgId?.isOnboarded) {
    return <Navigate to={paths.home} replace />;
  }

  return <Outlet />;
};

export default OnboardingRoute;
